import { swiffyslider } from 'swiffy-slider'
import "swiffy-slider/css"
import { useEffect } from 'react';

import '../Main.css'

import img_1 from "./img/img_1.jpg"
import img_2 from "./img/img_2.jpg"
import img_3 from "./img/img_3.jpg"
import img_4 from "./img/img_4.jpg"
import img_5 from "./img/img_5.jpg"
import img_6 from "./img/img_6.jpg"
const Main = () => {
    const arr = [img_1, img_2, img_3, img_4, img_5, img_6]

    useEffect(() => {
        window.swiffyslider = swiffyslider;
        const timer = setTimeout(() => {
            swiffyslider.init();
        }, 100); // pequeno delay garante que o DOM esteja pronto

        return () => clearTimeout(timer);
    }, []);
        
    return (
        <div className='main'>
            <h1 className='titleMain'> Marauders Society</h1>
            <p className='subtitleMain'> "I Solemnly Swear That I Am Up to No Good" </p>
            <div className='swiffy-slider slider-item-show3 slider-item-reveal slider-nav-autoplay' data-slider-nav-autoplay-interval="2500">
                <ul className="slider-container">
                    {arr.map((item, index) => (
                        <li>
                            <a href='/home' className='slide'>
                                <img src={item} alt={`img_${index + 1}`} />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <p className='password'> Clique em uma das imagens </p>
        </div>
    )
}

export default Main;